export const locales = ['da', 'en', 'es', 'no'];
